module.exports = __webpack_public_path__ + "static/media/customer-support-illustration.6e80729a.svg";